import { ConsentHtmlSignDocument } from '../../../ts/interfaces/documents/consent-html-sign-document';
import { signRepositoryInstance } from '../../../hexagonal-architecture-frontend-base/src/infrastructure/instances/signRepository';
import { signServices } from '../../../hexagonal-architecture-frontend-base/src/infrastructure/services/sign.service';

export const getHtmlSignDocumentService = async ({docId,locale,geoLocation,ipAddress,userAgent,metadata,quoteId,patientName,tutorEmail}: ConsentHtmlSignDocument) => {
  const response = await signServices(signRepositoryInstance).getHtmlSignDocument(
    docId,
    locale,
    geoLocation,
    ipAddress,
    userAgent,
    metadata,
    quoteId,
    patientName,
    tutorEmail,
  );

  console.log('RESPONSE IN GET HTML SIGN DOCUMENT SERVICE ', response.data)
  if (response === 'invalidFile') throw new Error(response);

  return response.data;
};
